import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './sections/header';
import ScrollProgress from './components/progress-bar';
import Footer from './sections/footer';
import Home from './pages/home';
import Service from './pages/service';
import Shopify from './pages/shopify';
import ShopifyPlus from './pages/shopify-plus';
import Magento from './pages/magento';
import Clients from './pages/clients';
import About from './pages/about-us';
import GetQuote from './pages/get-quote';
import Portfolio from './pages/portfolio';
import Careers from './pages/careers';
import NotFound from './pages/404';
import './App.scss';

function App() {  
  return (
    <Router>
      <div className="App">
        <Header />
        <ScrollProgress />
        <div className="mainWrapper">
          <Switch>    
            <Route path="/services/:id" component={Service} />
            <Route path="/careers" exact component={Careers} />
            <Route path="/magento" exact component={Magento} />
            <Route path="/shopify-plus" exact component={ShopifyPlus} />
            <Route path="/shopify" exact component={Shopify} />
            <Route path="/clients" exact component={Clients} />
            <Route path="/about-us" exact component={About} />
            <Route path="/get-quote" exact component={GetQuote} />
            <Route path="/portfolio" exact component={Portfolio} />
            <Route path="/" exact component={Home} />
            <Route path="*" exact component={NotFound} />            
          </Switch>
        </div>
        <Footer extraClass='mainFooter' />
      </div>
    </Router>
  );
}

export default App;
